module.exports = {
      id: "olympic-usage",
      viewBox: "0 0 11.388 19.966",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#olympic",
      toString: function () {
        return this.url;
      }
    }